import type { MonarchCurrencySelectorProps } from "@/monarch/types/MonarchCurrencySelector";

export type CurrencySelectorSurface = "hero" | "sideRail" | "stickyBar";

export type ResolvedCurrencySurfaces = Record<CurrencySelectorSurface, boolean>;

const EMPTY_SURFACES: ResolvedCurrencySurfaces = {
  hero: false,
  sideRail: false,
  stickyBar: false,
};

export const resolveCurrencySurfaces = (
  currencySelector?: MonarchCurrencySelectorProps | null,
): ResolvedCurrencySurfaces => {
  if (!currencySelector) {
    return EMPTY_SURFACES;
  }

  if (currencySelector.surfaces) {
    return {
      hero: currencySelector.surfaces.hero ?? false,
      sideRail: currencySelector.surfaces.sideRail ?? false,
      stickyBar: currencySelector.surfaces.stickyBar ?? false,
    };
  }

  if (currencySelector.placement === "currency-bar") {
    return { hero: false, sideRail: false, stickyBar: true };
  }

  return { hero: true, sideRail: true, stickyBar: false };
};
